import React from 'react'
import PropTypes from 'prop-types'

import ItemsSearchUrlBuilder from 'Utils/ItemsSearchUrlBuilder'
import WithDraggableList from 'Pods/Shared/Hocs/WithDraggableList'

class UserCategoryTags extends React.Component {
  render() {
    const urlBuilder = new ItemsSearchUrlBuilder()

    return (
      <ul className="job-list-item__labels">
        {Object.keys(this.props.tags).length > 0 && Object.keys(this.props.tags).map((key) => {
          if (this.props.categoryFilter === 'print_ready') {
            urlBuilder.set({
              pathname: `/3d-print-models/${key.replace(/\W+/g, '-')}`,
              search: '?',
            })
          } else {
            urlBuilder.set({
              pathname: `/3d-models/${key.replace(/\W+/g, '-')}`,
              search: `?${this.props.categoryFilter}=1`,
            })
          }
          const url = urlBuilder.applyFilter('author', this.props.author)

          return (
            <li
              key={`category-${this.props.category}-tag-${key}`}
              className="label label--white label--with-count"
            >
              <a href={url} target="_blank" rel="nofollow">
                {key}
                <span>{this.props.tags[key]}</span>
              </a>
            </li>
          )
        })
        }
      </ul>
    )
  }
}

UserCategoryTags.propTypes = {
  category: PropTypes.string.isRequired,
  categoryFilter: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  tags: PropTypes.object,
}

UserCategoryTags.defaultProps = {
  tags: {},
}

export default WithDraggableList(UserCategoryTags)
